import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxflightselector';
export const route = 'cnxflightselector/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxflightselector" */
/* webpackPrefetch: true */
'../components/FlightSelectorPage')));